// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgh_a big_wj big_ss big_xl"};